import { useState, useCallback } from "react";
import api from "../services/api";

export const useClassAllocations = () => {
  const [allocations, setAllocations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filtering, setFiltering] = useState(false);
  const [pagination, setPagination] = useState({
    current_page: 1,
    last_page: 1,
    per_page: 15,
    total: 0,
  });

  const fetchAllocations = useCallback(async (page = 1, filters = {}, isFiltering = false, perPage = null) => {
    try {
      if (isFiltering) {
        setFiltering(true);
      } else {
        setLoading(true);
      }
      
      const params = { page, per_page: perPage || pagination.per_page, ...filters };
      Object.keys(params).forEach((key) => {
        if (params[key] === "" || params[key] === undefined) {
          delete params[key];
        }
      });

      const response = await api.get('/report-card/class-teacher-allocations', { params });
      
      if (response.data?.data) {
        setAllocations(response.data.data);
        setPagination({
          current_page: response.data.current_page,
          last_page: response.data.last_page,
          per_page: response.data.per_page,
          total: response.data.total,
        });
      }
    } catch (error) {
      console.error("Error fetching allocations:", error);
      setAllocations([]);
    } finally {
      setLoading(false);
      setFiltering(false);
    }
  }, [pagination.per_page]);

  const createAllocation = async (data) => {
    return await api.post('/report-card/class-teacher-allocations', data);
  };

  const updateAllocation = async (id, data) => {
    return await api.put(`/report-card/class-teacher-allocations/${id}`, data);
  };

  const deleteAllocation = async (id) => {
    return await api.delete(`/report-card/class-teacher-allocations/${id}`);
  };

  return {
    allocations,
    loading,
    filtering,
    pagination,
    fetchAllocations,
    createAllocation,
    updateAllocation,
    deleteAllocation,
  };
};
